import { gsap } from '../gsap/setup';

export function initLeftovers() {
  const $block = $('.leftovers');

  if (!$block.length) return;

  const $hero = $block.find('.leftovers__hero');
  const $marquee = $block.find('.leftovers__marquee');

  gsap.to($marquee[0], {
    duration: 1,
    x: '-20%',
    scrollTrigger: {
      trigger: $hero[0],
      start: 'top top',
      end: 'bottom top',
      scrub: true,
      ease: 'power1.inOut',
    },
  });
}
